module.exports = __webpack_public_path__ + "img/journal-minus.2f98e160.svg";